const getElementId = (type, height, width) => `${type}-${width}-${height}`

export default getElementId
